import { useTaskGridPreferencesQuery, useUpdateTaskGridPreferencesMutation } from "./queries";
import type { SortMode } from "../types";

/**
 * Sort preference for the matrix. Backed by server-side task_grid_preferences.
 * Default "start_date_asc" lines hires up chronologically so the People Team's
 * eye lands on whoever is closest to (or furthest into) their journey first.
 */
export default function useSortMode(): {
  sort: SortMode;
  setSort: (next: SortMode) => void;
} {
  const prefsQuery = useTaskGridPreferencesQuery();
  const updatePrefs = useUpdateTaskGridPreferencesMutation();

  const sort: SortMode = prefsQuery.data?.sort ?? "start_date_asc";

  const setSort = (next: SortMode) => {
    if (next === sort) return;
    updatePrefs.mutate({ sort: next });
  };

  return { sort, setSort };
}
